import {newStepValue} from '../../../../services/flowBuilder/utils/constants';

const optionSeperator = '. ';

const multipleGroupsOn = {
    json: {
        menu: {
            menuType: 'multipleChoice',
            menuHeader: '',
            imageRef: '',
            bodyText: '',
            input: {
                varName: '',
            },
            menuParams: {
                multipleGroups: true,
                groupTitle: '',
                displayType: 'number'
            },
            groups: {
                1: {
                    groupTitle: '',
                    multipleSelection: false,
                    items: {
                        1: {
                            text: '',
                            value: '',
                            imageRef: '',
                            bodyText: '',
                        },
                    },
                }
            },
        },
        type: 'menu',
        next: newStepValue,
    },
    paths: [
        'menu.imageRef',
        'menu.menuParams.displayType',
        'menu.menuHeader',
        'menu.menuParams.groupTitle',
        'menu.bodyText',
        'menu.input.varName',
        'menu.menuParams.multipleGroups',
        // 'menu.menuParams.multipleSelection',
        'menu.options.optionSeperator',
        'menu.options.items.#',
        'next',
    ],
    groups: [
        {
            Parameters: [
                'menu.imageRef',
                'menu.menuParams.displayType',
                'menu.menuHeader',
                'menu.menuParams.groupTitle',
                'menu.bodyText',
                'menu.input.varName',
                'menu.menuParams.multipleGroups',
                // 'menu.menuParams.multipleSelection',
                'menu.options.optionSeperator',
            ],
        },
        {
            Logic: ['menu.options.items.#', 'next'],
        },
    ],
};

const multipleGroupsOff = {
    json: {
        menu: {
            menuType: 'multipleChoice',
            menuHeader: '',
            imageRef: '',
            bodyText: '',
            input: {
                varName: '',
            },
            menuParams: {
                multipleSelection: false,
                multipleGroups: false,
                groupTitle: '',
                displayType: 'number'
            },
            options: {
                optionSeperator,
                items: {
                    1: {
                        text: '',
                        value: '',
                        imageRef: '',
                        bodyText: '',
                    },
                },
                keywords: {
                    1: [],
                },
            },
        },
        type: 'menu',
        next: newStepValue,
    },
    paths: [
        'menu.imageRef',
        'menu.menuParams.displayType',
        'menu.menuHeader',
        'menu.menuParams.groupTitle',
        'menu.bodyText',
        'menu.input.varName',
        'menu.menuParams.multipleGroups',
        'menu.menuParams.multipleSelection',
        'menu.options.optionSeperator',
        'menu.options.items.#',
        'next',
    ],
    groups: [
        {
            Parameters: [
                'menu.imageRef',
                'menu.menuParams.displayType',
                'menu.menuHeader',
                'menu.menuParams.groupTitle',
                'menu.bodyText',
                'menu.input.varName',
                'menu.menuParams.multipleGroups',
                'menu.menuParams.multipleSelection',
                'menu.options.optionSeperator',
            ],
        },
        {
            Logic: ['menu.options.items.#', 'next'],
        },
    ],
};

export const multipleChoice = {
    json: {
        menu: {
            menuType: 'multipleChoice',
            menuHeader: '',
            imageRef: '',
            bodyText: '',
            input: {
                varName: '',
            },
            menuParams: {
                multipleSelection: false,
                multipleGroups: false,
                groupTitle: '',
                displayType: {}
            },
            options: {
                optionSeperator,
                items: {
                    1: {
                        text: '',
                        value: '',
                        imageRef: '',
                        bodyText: '',
                    },
                },
                keywords: {
                    1: [],
                },
            },
            groups: {
                1: {
                    groupTitle: '',
                    multipleSelection: false,
                    items: {
                        1: {
                            text: '',
                            value: '',
                            imageRef: '',
                            bodyText: '',
                            keywords: []
                        },
                    },
                }
            },
        },
        type: 'menu',
        next: newStepValue,
    },
    paths: [
        'menu.imageRef',
        'menu.menuParams.displayType',
        'menu.menuHeader',
        'menu.menuParams.groupTitle',
        'menu.bodyText',
        'menu.input.varName',
        'menu.menuParams.multipleGroups',
        'menu.menuParams.multipleSelection',
        'menu.options.optionSeperator',
        'menu.options.items.#',
        'next',
    ],
    groups: [
        {
            Parameters: [
                'menu.imageRef',
                'menu.menuParams.displayType',
                'menu.menuHeader',
                'menu.menuParams.groupTitle',
                'menu.bodyText',
                'menu.input.varName',
                'menu.menuParams.multipleGroups',
                'menu.menuParams.multipleSelection',
                'menu.options.optionSeperator',
            ],
        },
        {
            Logic: ['menu.options.items.#', 'next'],
        },
    ],
    layout: {
        menuHeader: {
            type: 'input',
            label: 'Menu Header',
            placeholder: 'Name the menu header',
            attributes: {
                optional: true
            }
        },
        imageRef: {
            type: 'image',
            label: '',
            validators: {
                required: false,
            },
        },
        bodyText: {
            type: 'textarea',
            label: 'Body Text',
            placeholder: 'Enter a body text',
            text: 'description',
            attributes: {
                required: true
            },
            validators: {
                required: true,
            },
        },
        multipleSelection: {
            type: 'checkbox-single',
            label: 'Multiple Selection',
        },
        multipleGroups: {
            type: 'checkbox-single',
            label: 'Multiple Groups',
            attributes: {
                options: {
                    true: 'true',
                    false: 'false',
                },
                data: true,
            },
        },
        groupTitle: {
            type: 'input',
            label: 'Sub Header',
            placeholder: 'Add a subheader',
            validators: {
                required: true,
            }
        },
        description: {
            type: 'input',
            label: '$',
            text: 'description',
            placeholder: 'Add description / subtext',
            validators: {
                required: false,
            },
            attributes: {
                optional: true
            }
        },
        varName: {
            type: 'text',
            label: 'Variable Name',
            placeholder: 'Enter name for variable',
            validators: {
                required: true,
            },
        },
        optionSeperator: {
            type: 'autocomplete',
            label: 'Option Separator',
            validators: {
                // optionSelected: true
            },
            attributes: {
                options: ['-'],
                optional: true
            },
        },
        value: {
            type: 'text',
            label: '$',
            text: 'value',
            placeholder: 'Assign a value to the result',
            validators: {
                required: false,
            },
        },
        next: {
            type: 'next',
            label: 'Point to',
            validators: {
                optionSelected: true,
            },
        },
        items: {
            dataType: 'item',
            attributes: {
                add: true,
                delete: true,
            },
        },
        text: {
            type: 'text',
            label: '$',
            text: 'option',
            placeholder: 'Add option text',
            validators: {
                required: true,
            },
        },
        keywords: {
            dataType: 'keyword',
            type: 'chips',
            label: '',
            placeholder: 'Add keyword(s)',
            validators: {
                maxLength: 5,
                duplicate: true,
            },
        },
        displayType: {
            type: 'dropdown',
            label: 'WhatsApp Display Type',
            attributes: {
                options: {
                    button: 'Reply Buttons',
                    list: 'List Message',
                    number: 'Numbered List',
                    auto: 'Auto Select'
                },
                warning: true
            },
            validators: {
                optionSelected: true
            }
        },
    },
    data: {
        // dataPath: 'menu.menuParams.multipleGroups',
        // multipleGroups: {
        //     true: multipleGroupsOn,
        //     false: multipleGroupsOff
        // },
        items: {
            imageRef: '',
            text: '',
            value: '',
            bodyText: '',
        },
        keywords: [],
    },
};
